let bool = process.env.NODE_ENV === "production";
export const HOST = bool
  ? `https://${window.location.host}/api/cloud`
  : "/api/cloud";